import { getLocalStorage } from "../../helpers/Utils";
import spikeViewApiService from "../../services/apiService";
import { GET_CONFIG_SETTINGS, CONFIG_ERROR_GENERATED } from "../types";

export const actionGetConfigSettings = (data) => async (dispatch) => {
  try {
    const request =
      !getLocalStorage("settingData") || data?.isApiRun
        ? await spikeViewApiService("getSettingData")
        : false;
    if (request && request.data.status === "Success") {
      let settingData = request.data.result;
      dispatch({ type: GET_CONFIG_SETTINGS, payload: settingData });
    }
    return request;
  } catch (error) {
    dispatch({ type: CONFIG_ERROR_GENERATED, error });
    return error;
  }
};
